// extracted by mini-css-extract-plugin
export default {"navigation-links":"navigation-links--NaLne"};